/**
 * WordPress dependencies
 */
import { Dashicon } from '@safe-wordpress/components';
import { useSelect } from '@safe-wordpress/data';
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import { store as NAB_DATA } from '@nab/data';

/**
 * Internal dependencies
 */
import './style.scss';
import { useExperimentAttribute } from '../../hooks';

export const NoQuotaWarning = (): JSX.Element | null => {
	const quota = useSelect(
		( select ) =>
			! select( NAB_DATA ).getPageAttribute( 'results/isPublicView' )
				? select( NAB_DATA ).getQuota()
				: undefined,
		[]
	);
	const status = useExperimentAttribute( 'status' );

	if ( ! quota || quota.availableQuota ) {
		return null;
	}

	if ( 'running' !== status ) {
		return null;
	}

	return (
		<div className="nab-results-experiment-sidebar__no-quota-warning">
			<Dashicon icon="warning" />
			<span>
				{ _x(
					'Event tracking has stopped because there’s no more quota available at the moment.',
					'text',
					'nelio-ab-testing'
				) }{ ' ' }
				{ _x(
					'The test is still active for current and new visitors, which means they’ll continue to see the correct variant, but the plugin will ignore their actions until your quota is reset.',
					'text',
					'nelio-ab-testing'
				) }
			</span>
		</div>
	);
};
